var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 173,
    viewBox: "0 0 208 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10490",
    "data-name": "Rectangle 10490",
    width: 208,
    height: 173,
    transform: "translate(1507 2965)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10476",
    "data-name": "Rectangle 10476",
    width: 140,
    height: 140,
    transform: "translate(4052 1877)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87727",
    "data-name": "Mask Group 87727",
    transform: "translate(-1507 -2965)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9884",
    "data-name": "Path 9884",
    d: "M2387.327-2211.623c32.955-28.485,85.1-33.736,125.317-15.562s63.948,52.284,56.145,84.231-38.513,43.217-87.089,49.143-83.344.35-100.874-19.435S2354.373-2183.138,2387.327-2211.623Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, -699.753, 5376.377)",
    fill: "#ebfffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87719",
    "data-name": "Mask Group 87719",
    transform: "translate(-2514 1108)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-information-5678356",
    d: "M155.129,18.969H88.718a8.046,8.046,0,0,0-5.7,2.381,8.162,8.162,0,0,0-2.364,5.739v24H31.025a7.99,7.99,0,0,0-5.642,2.405,8.1,8.1,0,0,0-2.307,5.716v45.981h0a8.048,8.048,0,0,0,2.331,5.658,7.924,7.924,0,0,0,5.618,2.348h7.295l16.752,16.872a2.314,2.314,0,0,0,2.536.508,2.344,2.344,0,0,0,1.437-2.165V113.192H97.436a7.987,7.987,0,0,0,5.674-2.324,8.1,8.1,0,0,0,2.388-5.682V81.076h21.61V96.293a2.344,2.344,0,0,0,1.437,2.165,2.314,2.314,0,0,0,2.536-.508l16.757-16.872h7.293a7.926,7.926,0,0,0,5.616-2.349,8.041,8.041,0,0,0,2.329-5.657V27.09a8.106,8.106,0,0,0-2.305-5.714,7.989,7.989,0,0,0-5.64-2.406Zm-54.287,86.217a3.354,3.354,0,0,1-1.011,2.382,3.3,3.3,0,0,1-2.4.936H56.714a2.323,2.323,0,0,0-1.646.686,2.347,2.347,0,0,0-.68,1.657v11.9L40.925,109.193a2.316,2.316,0,0,0-1.645-.687H31.022a3.309,3.309,0,0,1-3.3-3.319V59.208a3.41,3.41,0,0,1,3.3-3.434c10.653,0,56.721,0,66.411,0a3.423,3.423,0,0,1,3.408,3.434v45.981Zm57.577-32.115a3.309,3.309,0,0,1-3.291,3.319c-2.54.194-9.2-.566-9.9.686L131.759,90.635v-11.9a2.353,2.353,0,0,0-.681-1.657,2.319,2.319,0,0,0-1.645-.686H105.495V59.206h0a8.159,8.159,0,0,0-2.364-5.74,8.045,8.045,0,0,0-5.7-2.381H85.307v-24a3.424,3.424,0,0,1,3.408-3.433h66.411a3.41,3.41,0,0,1,3.291,3.433Zm-36.555-20.7h0a2.346,2.346,0,1,1,2.248-2.344,2.338,2.338,0,0,1-2.248,2.344Zm10.315,0h0a2.346,2.346,0,1,1,2.247-2.344,2.338,2.338,0,0,1-2.247,2.344Zm-20.632,0h0a2.346,2.346,0,1,1,2.248-2.344,2.338,2.338,0,0,1-2.248,2.344Z",
    transform: "translate(4028.925 1872.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-heart",
    "data-name": "Icon feather-heart",
    d: "M31.26,6.932a8.208,8.208,0,0,0-11.67,0L18,8.534l-1.59-1.6a8.21,8.21,0,0,0-11.67,0,8.354,8.354,0,0,0,0,11.754l1.59,1.6L18,32.042,29.67,20.288l1.59-1.6a8.352,8.352,0,0,0,0-11.754Z",
    transform: "translate(4075.612 1936.788)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsider);
export default __webpack_public_path__ + "static/media/Insider.a28213fa4630b5d7f77b521c7d9d6d3c.svg";
export { ForwardRef as ReactComponent };